module.exports = __webpack_public_path__ + "media/images/img_top_catch_sp-bdf01413c9ac2e3ac1b919de7340d1c9.png";